module.exports = __webpack_public_path__ + "static/media/arwor-left-grey.d35236ab.svg";